'use client';

import React from 'react';
import { CheckCircle, XCircle, CalendarOff } from 'lucide-react';
import { toast } from 'sonner';
import Avatar from '@/components/ui/Avatar';

// Backend integration: fetch from /api/time-off-requests?status=pending
const PENDING_REQUESTS = [
  {
    id: 'tor-001',
    staff: 'Molly Nicholson',
    title: 'Co-Director of Education',
    dates: 'Apr 14–15',
    type: 'Personal',
    affectsItems: 3,
  },
  {
    id: 'tor-002',
    staff: 'Christopher Fahmie',
    title: 'Asst. Arts Administrator',
    dates: 'Apr 21',
    type: 'Medical',
    affectsItems: 1,
  },
];

export default function PendingApprovalsWidget() {
  function handleApprove(id: string, name: string) {
    // Backend integration: PATCH /api/time-off-requests/:id { status: 'approved' }
    toast.success(`Time off approved for ${name}`);
  }

  function handleDeny(id: string, name: string) {
    // Backend integration: PATCH /api/time-off-requests/:id { status: 'denied' }
    toast.error(`Time off denied for ${name}`);
  }

  if (PENDING_REQUESTS.length === 0) return null;

  return (
    <div className="bg-white rounded-xl border border-stone-100 shadow-card overflow-hidden">
      <div className="px-4 py-3 border-b border-stone-100 flex items-center gap-2">
        <CalendarOff size={14} className="text-slate-400" />
        <h3 className="text-[13px] font-semibold text-slate-700">Pending Approvals</h3>
        <span className="ml-auto text-[11px] font-semibold bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded-full">
          {PENDING_REQUESTS.length}
        </span>
      </div>

      <div className="divide-y divide-stone-50">
        {PENDING_REQUESTS.map((req) => (
          <div key={req.id} className="px-4 py-3">
            <div className="flex items-start gap-2.5">
              <Avatar name={req.staff} size="xs" />
              <div className="flex-1 min-w-0">
                <p className="text-[13px] font-medium text-slate-800">{req.staff}</p>
                <p className="text-[11px] text-slate-400">{req.dates} · {req.type}</p>
                {req.affectsItems > 0 && (
                  <p className="text-[11px] text-amber-600 mt-0.5">{req.affectsItems} items affected</p>
                )}
              </div>
              <div className="flex items-center gap-1.5 shrink-0">
                <button
                  onClick={() => handleApprove(req.id, req.staff)}
                  className="p-1 rounded-md hover:bg-emerald-50 text-slate-300 hover:text-emerald-600 transition-colors"
                  aria-label={`Approve time off for ${req.staff}`}
                >
                  <CheckCircle size={16} />
                </button>
                <button
                  onClick={() => handleDeny(req.id, req.staff)}
                  className="p-1 rounded-md hover:bg-red-50 text-slate-300 hover:text-red-500 transition-colors"
                  aria-label={`Deny time off for ${req.staff}`}
                >
                  <XCircle size={16} />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}